export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Nuclear Energy Educator — London, United Kingdom',
    'My students finally understand the difference between radioactivity, fission, and nuclear energy production. I used to waste hours searching for the right way to explain how nuclear processes work. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Physics Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain nuclear safety, radiation protection, or how to teach decision-making in nuclear energy contexts. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Science and Energy Teacher — Amsterdam, Netherlands',
    'The lesson planning saves me countless hours. The integrated nuclear energy projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Nuclear Energy Educator | London, United Kingdom',
    "The material on nuclear fission and energy production completely changed how my students understand nuclear energy. They finally grasp how it works and why it matters. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Physics Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Science Teacher | Berlin, Germany',
    "The 50 nuclear energy projects transformed how my students see real-world applications. Now they investigate reactor safety, analyze waste management solutions, understand energy systems, and grasp why nuclear energy matters professionally and globally. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The nuclear energy terminology handbook gave me back my class time. I used to spend time explaining nuclear concepts and misconceptions. Now I show the handbook and students instantly understand nuclear energy concepts.',
  ],
  [
    'MS',
    'Martin S.',
    'Nuclear Energy Instructor | Copenhagen, Denmark',
    "The 100 case studies were eye-opening. My students finally understand why all this matters. They're analyzing real nuclear challenges, making energy decisions, addressing safety concerns, and exploring how nuclear fits in our energy future. This completely transformed how they see nuclear energy.",
  ],
];
